import React from "react";

const CloseIcon = () => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M25.3346 8.54666L23.4546 6.66666L16.0013 14.12L8.54797 6.66666L6.66797 8.54666L14.1213 16L6.66797 23.4533L8.54797 25.3333L16.0013 17.88L23.4546 25.3333L25.3346 23.4533L17.8813 16L25.3346 8.54666Z" fill="#999999"/>
        </svg>
    )
}
export default CloseIcon